export default __webpack_public_path__ + "static/media/minting-loader.332ada0b.svg";